import get from 'lodash/get';

const Table = {
	years: { title: 'Years', singular: { title: 'Year' } },
	categories: { title: 'Categories', singular: { title: 'Category' } },
	tags: { title: 'Tags', singular: { title: 'Tag' } },
	about: { title: 'About' },
	clients: {
		title: 'Clients',
		pub: { title: 'Publication' },
		comm: { title: 'Commercial' },
		agency: { title: 'Agency' },
		fashion: { title: 'Fashion' },
	}
};

const Dictionary = {
	get: ( key, fallback ) => {
		const searchIn = (Array.isArray(key))? key.concat('title') : [key, 'title'];
		return get( Table, searchIn, fallback || key );
	}
}

export default Dictionary;


// WEBPACK FOOTER //
// ./src/dictionary.js